
const RELOAD_UPDATED = 'RELOAD_UPDATED';

export const reloadUpdated = reload => ({type: RELOAD_UPDATED, reload});

export const checkVersion = () => dispatch => {
    if (process.env.NODE_ENV === 'production') {
        const args = {
            headers: {
                'cache-control': 'no-cache'
            }
        };

        return fetch('ver.json', args)
            .then(response => response.body.getReader().read())
            .then(body => {
                const decoder = new TextDecoder('utf-8');
                const ver = decoder.decode(body.value, {stream: true});
                const json = JSON.parse(ver);
                const scripts = document.getElementsByTagName('script');
                const arrScripts = Array.prototype.slice.call(scripts);
                const hasChanged = arrScripts.reduce((ret, script) => {
                    if (ret) {
                        return ret;
                    }

                    const scriptName = script.src;
                    const arrFileName = scriptName.split('/').pop();
                    const arrName = arrFileName.split('.');
                    const [name, hash] = arrName;

                    /* if (name === 'analytics') {
                        return false;
                    }*/

                    return hash !== json[name];
                }, false);

                if (hasChanged) {
                    console.info('Reloading');
                } else {
                    console.info('It\'s updated');
                }

                dispatch(reloadUpdated(false));
            });
    }

    return Promise.resolve(false);
};

// Reducer
const _defaultState = () => ({
    reload: false
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case RELOAD_UPDATED:
        return {
            ...state,
            reload: action.reload
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/updateApp.js